import api from "../api/axiosInstance";

const statsService = {
    getAdminOverview: () => api.get("/stats/admin-overview"),
};

export default statsService;
